// @eidollon/contracts/me
//
// Per-operator relations to a Zone-A entity (track + pipeline membership).
// Backs the hassle-free Track / Add-to-Pipeline buttons rendered in
// ObjectHeader.actions on detail pages, and the GET-on-mount probe used to
// render initial button state.
//
// Wire shapes:
//   GET    /v1/me/relations?entity_type=&entity_id=  → RelationsResponse
//   POST   /v1/me/track       ← TrackTargetBody       → TrackResponse
//   DELETE /v1/me/track       ← TrackTargetBody       → TrackResponse (tracked:false)
//   POST   /v1/me/pipeline    ← PipelineTargetBody    → PipelineResponse
//   DELETE /v1/me/pipeline    ← PipelineTargetBody    → PipelineResponse (in_pipeline:false)

import { z } from 'zod';

export const TrackableEntityType = z.enum([
  'tender',
  'award',
  'legal_entity',
  'agency',
  'standing_offer',
]);
export type TrackableEntityType = z.infer<typeof TrackableEntityType>;

export const EntityRef = z
  .object({
    entity_type: TrackableEntityType,
    entity_id: z.string().uuid(),
  })
  .strict();
export type EntityRef = z.infer<typeof EntityRef>;

export const TrackTargetBody = EntityRef;
export type TrackTargetBody = z.infer<typeof TrackTargetBody>;

export const TrackResponse = z
  .object({
    tracked: z.boolean(),
    /** ID of the watchlist_items row, present when tracked=true. */
    watchlist_item_id: z.string().uuid().nullable(),
    /** ID of the auto-created `my-tracked` watchlist for this tenant. */
    watchlist_id: z.string().uuid().nullable(),
  })
  .strict();
export type TrackResponse = z.infer<typeof TrackResponse>;

export const PipelineTargetBody = EntityRef;
export type PipelineTargetBody = z.infer<typeof PipelineTargetBody>;

export const PipelineResponse = z
  .object({
    in_pipeline: z.boolean(),
    pipeline_item_id: z.string().uuid().nullable(),
  })
  .strict();
export type PipelineResponse = z.infer<typeof PipelineResponse>;

export const RelationsResponse = z
  .object({
    tracked: z.boolean(),
    in_pipeline: z.boolean(),
  })
  .strict();
export type RelationsResponse = z.infer<typeof RelationsResponse>;
